<template>
    <iframe v-if ="item && (item.url_youtube)" id="ancora-youtube" type="text/html" width="370" height="210"
        :src=urlYoutube
        frameborder="0"/>
</template>

<script>
export default {
    name:'LinkYoutube',
    props: {
        item: {
            default:Object,
            type: Object
        }
    },
    computed: {
        urlYoutube(){
            let url = this.item.url_youtube.slice(-11);
            return "https://youtube.com/embed/" + url
        }
    }
}
</script>

<style scoped>
#ancora-youtube {
    display: block;
    margin: 15px 0px 8px 0px;
}
</style>
